var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection-view-back"},[_c('SvgIcon',{staticClass:"collection-view-back-icon",attrs:{"icon":_vm.icons.SvgArrow}}),_vm._v(" "+_vm._s(_vm.t.t('params.back'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }